// extracted by mini-css-extract-plugin
export var footer = "_n2-5";
export var fulfillmentInput = "_n2-0";
export var shipDateInput = "_n2-1";
export var shipmentModal = "_n2-2";
export var shipmentModalContent = "_n2-3";
export var tableContainer = "_n2-4";